import { withSvgIconSimple } from './withSvgIconSimple';

export const IntegrationsIcon = withSvgIconSimple(
  <>
    <path
      d="M9 5C9 4.44772 9.44772 4 10 4H14C14.5523 4 15 4.44772 15 5V9C15 9.55228 14.5523 10 14 10H10C9.44772 10 9 9.55228 9 9V5Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M3 14.5C3 13.9477 3.44772 13.5 4 13.5H8C8.55228 13.5 9 13.9477 9 14.5V18.5C9 19.0523 8.55228 19.5 8 19.5H4C3.44772 19.5 3 19.0523 3 18.5V14.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M15 14.5C15 13.9477 15.4477 13.5 16 13.5H20C20.5523 13.5 21 13.9477 21 14.5V18.5C21 19.0523 20.5523 19.5 20 19.5H16C15.4477 19.5 15 19.0523 15 18.5V14.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M9 19.3263C9.90926 19.7583 10.9264 20 12 20C13.0736 20 14.0907 19.7583 15 19.3263M9 6.67358C6.63505 7.79705 5 10.2076 5 13C5 13.3689 5.02854 13.7311 5.08352 14.0846M15 6.67358C17.3649 7.79705 19 10.2076 19 13C19 13.3689 18.9715 13.7311 18.9165 14.0846"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
